import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Layout from '../layout/Layout';

const AdminRoute = ({ children }) => {
  const { currentUser, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white z-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-12 h-12 rounded-full border-4 border-primary-100 border-t-primary-500 animate-spin" />
          <p className="text-sm text-gray-400 tracking-wide">Loading…</p>
        </div>
      </div>
    );
  }
  
  // Check if user is authenticated and has admin privileges
  if (!isAuthenticated || !currentUser?.is_admin) {
    return <Navigate to="/" />;
  }
  
  return (
    <Layout>
      {children}
    </Layout>
  );
};

export default AdminRoute;